import clsx from 'clsx';
import Image from 'components/common/Image';
import { ChoiceProps } from 'interfaces/cms/content';
import styles from './Choice.module.scss';

export interface ChoicePropsInterface extends ChoiceProps {
  isChoiceSelected: (code: string) => boolean;
  onSelectChoice: (code: string) => void;
}

function Choice({
  code,
  displayName,
  icon,
  onSelectChoice,
  isChoiceSelected,
}: Readonly<ChoicePropsInterface>) {
  return (
    <div
      className={clsx(
        'text-center',
        styles.choice,
        isChoiceSelected(code) && 'bg-backgroundHoverColor',
        isChoiceSelected(code) ? 'border-primaryColor' : 'border-white'
      )}
      onClick={() => onSelectChoice(code)}
    >
      {icon && (
        <div
          style={{
            width: `${icon.width}px`,
            height: `${icon.height}px`,
            position: 'relative',
          }}
        >
          <Image src={icon.url} fill alt={icon.alt || icon.name} />
        </div>
      )}
      <p
        className={clsx(
          'text-sm',
          isChoiceSelected(code) ? 'text-primaryColor' : 'text-textColor'
        )}
      >
        {displayName}
      </p>
    </div>
  );
}

export default Choice;
